import { apiFetch } from './apiFetch'

export interface Intake {
  /** Whether the department is taking complaints at all. */
  accepting: boolean
  /**
   * The interval the closure notice tells a complainant to check back in, e.g.
   * "3 rotations of Venus". Quoted once, when the window closes, so the notice
   * says the same thing every time it is read. Null while the window is open.
   */
  reopenEstimate: string | null
  /** When the window was last opened or closed. Null if it never has been. */
  updatedAt: number | null
}

/**
 * Reading the state is deliberately not secret: the filing page has to know
 * whether the window is open before it puts a form in front of a child.
 * Setting it lives behind the department's own path -- see `setIntake` in
 * ./admin.
 */
export function getIntake(): Promise<Intake> {
  return apiFetch<Intake>('/intake')
}
